import React, { FC, CSSProperties, useState } from "react";
import Icon from "../Icon";
import { useStyles } from "./ItemImageStyles";

const ItemImage: FC<{
  src?: string | { old?: string | null; new?: string | null } | null;
  alt?: string;
  sDefault?: CSSProperties;
  sFallback?: CSSProperties;
  fit?: boolean;
  objectPosition?: CSSProperties["objectPosition"];
}> = ({ src, alt, sDefault, sFallback, fit, objectPosition }) => {
  const [usePlaceholder, setUsePlaceholder] = useState<boolean>(false);

  const styles = useStyles();

  if (usePlaceholder) {
    return (
      <div className={styles.imageContainer} style={sFallback}>
        <Icon icon="PlaceholderThumbnail" />
      </div>
    );
  }

  return (
    <div className={styles.imageContainer} style={sDefault ?? {}}>
      {typeof src === "string" ? (
        <img
          className={styles.img}
          style={{
            objectFit: fit ? "cover" : "contain",
            objectPosition: objectPosition ?? "center",
          }}
          alt={alt}
          src={src}
          onError={() => setUsePlaceholder(true)}
        />
      ) : (
        <>
          <img
            className={styles.img}
            style={{
              objectFit: fit ? "cover" : "contain",
              objectPosition: objectPosition ?? "center",
            }}
            alt={alt}
            src={src?.new || ""}
            onError={() => setUsePlaceholder(true)}
          />
          <div
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "30%",
              height: "30%",
            }}>
            <div style={{ position: "relative" }}>
              <img
                className={styles.img}
                style={{
                  objectFit: fit ? "cover" : "contain",
                  objectPosition: objectPosition ?? "center",
                }}
                alt={alt}
                src={src?.old || ""}
                onError={() => setUsePlaceholder(true)}
              />
              <div
                style={{ position: "absolute", top: "-11px", right: "-11px" }}>
                <Icon icon="Exchange" />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ItemImage;
